<div class="mobi-ui-relative no-heading-spacing">
  <div class="mobi-ui-slot-major is-top-center !absolute !top-[-16px] lg:!top-[-30px]">
    <div class="w-[98px] lg:w-[128px] block view-enter-animation mx-auto">
      <mobi-ui-illustration-major
        [illustration]="{
          name: 'basic_concierge_male',
          file: { entity: { filename: 'basic_concierge_male.svg' } },
        }"
        class="block"
      />
    </div>
  </div>
  <div
    class="mobi-ui-container flex flex-col items-center mobi-ui-text-center view-enter-animation"
  >
    <h2 class="mobi-ui-text-inked mobi-ui-font-h3">
      {{
        'concierge_title'
          | texts
            : {
                context: 'frontend',
                default: 'Wünschen Sie Unterstützung?',
              }
      }}
    </h2>
    <span
      class="text-lead mobi-ui-font-tisa mobi-ui-font-light mobi-ui-font-italic mobi-ui-padding-b-sm"
    >
      {{
        'concierge_subtitle'
          | texts: { context: 'frontend', default: 'Kontaktieren Sie uns!' }
      }}
    </span>
    <a
      [href]="contactUrl()"
      class="outline-link-btn mobi-ui-btn-silent is-squared justify-between gap-3 mobi-ui-padding-y-md w-fit mobi-ui-animation-scale-up-init mobi-ui-animation-scale-up-hover"
    >
      <span class="flex items-center">
        <mobi-ui-icon-major name="message_conversation" class="mr-[12px]" />
        <span class="flex items-center">
          {{
            'concierge_cta_text'
              | texts
                : {
                    context: 'frontend',
                    default: 'Zu den Kontaktmöglichkeiten',
                  }
          }}
        </span>
      </span>
      <mobi-ui-icon-major
        name="right"
        class="mobi-ui-animation-horizontal-wiggle-hover-target"
      />
    </a>
  </div>
</div>
